import { useState, useEffect } from 'react';

function readStoredState(key, initialState) {
  try {
    const storedState = sessionStorage.getItem(key);
    if (!storedState || storedState === 'undefined' || storedState === 'null') {
      return initialState;
    }
    return JSON.parse(storedState);
  } catch {
    sessionStorage.removeItem(key);
    return initialState;
  }
}

const useSyncedState = (initialState, key, stateExportKey, setStateExportKey) => {
  const [state, setState] = useState(() => readStoredState(key, initialState));

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === key) {
        setState(readStoredState(key, initialState));
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [initialState, key]);

  function parseDateStrings(data) {
    if (Array.isArray(data)) {
      for (const obj of data || []) {
        if (obj && obj.hasOwnProperty('startDate') && obj.hasOwnProperty('endDate')) {
          obj.startDate = new Date(obj.startDate);
          obj.endDate = new Date(obj.endDate);
        }
      }
    } else if (typeof data === 'object' && data !== null) {
      for (const itemKey in data) {
        const obj = data[itemKey];
        if (obj && obj.hasOwnProperty('startDate') && obj.hasOwnProperty('endDate')) {
          obj.startDate = new Date(obj.startDate);
          obj.endDate = new Date(obj.endDate);
        }
      }
    }

    return data;
  }

  const setSyncedState = (newState) => {
    setState((previousState) => {
      const resolvedState =
        typeof newState === 'function' ? newState(previousState) : newState;
      sessionStorage.setItem(key, JSON.stringify(resolvedState));
      return resolvedState;
    });
  };

  const parsedState = typeof state === 'object' ? parseDateStrings(state) : state;

  return { [stateExportKey]: parsedState, [setStateExportKey]: setSyncedState };
};

export default useSyncedState;
